module.exports = __webpack_public_path__ + "img/03魏智海.4403791d.jpg";